import { render, staticRenderFns } from "./Licbar.vue?vue&type=template&id=acd2fefc&scoped=true&"
import script from "./Licbar.vue?vue&type=script&lang=js&"
export * from "./Licbar.vue?vue&type=script&lang=js&"
import style0 from "./Licbar.vue?vue&type=style&index=0&id=acd2fefc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd2fefc",
  null
  
)

export default component.exports